<div style="width:100%">
  <main>
    <article #fs fullscreen-able [class.is-active]="isActive" style="background-color: white; position: relative;">
      <icon-chart [headerConfig]="item?.config?.widget_header_configuration" [iconList]="iconList" [data]="data"
        [pageKey]="pageKey" [chartName]="divId" [config]="UpsetChartContainer" [fullscreen]="isFullscreen" [expand]="fs"
        [item]="item">
      </icon-chart>


      <div class="chart-controls">

        <div class="selection-display">{{ getSelectionText() }}</div>

        <div class="button-group">
          <button *ngIf="isOverflowing" class="control-button" (click)="toggleShowMore()">
            {{ showMore ? 'Show Less' : 'Show More' }}
          </button>
          <button class="control-button" (click)="filterData()">
            Filter
          </button>
          <button class="control-button" (click)="resetChart()">
            Reset
          </button>
          <button class="nav-arrow-button" (click)="goToPixelMap($event)" title="Go to Pixel Map">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor">
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" />
            </svg>
          </button>
        </div>
      </div>

      <div id="upset_chart" #UpsetChartContainer [class.expanded]="showMore"></div>

      <div class="upset-tooltip"></div>

    </article>
  </main>
</div>